import { render } from "./LoaderFiles.vue?vue&type=template&id=38a8bb98"
const script = {}
script.render = render

export default script